<sc-sized-container [minWidth]="500" class="no-field-space">
  <sc-dialog-title>
    <sc-dictionary-label
      dictionaryKey="tmc-yard.ui.control.sac-client.suspend-station-dialog.title"></sc-dictionary-label>
  </sc-dialog-title>
  <sc-padding leftRightOnly [formGroup]="formGroup">
    <sc-text-field labelDictionaryKey="tmc-yard.entity.transport.currentPosition.hint" formControlName="note"></sc-text-field>
    <app-service-response [responseMessages]="responseMessages"></app-service-response>
  </sc-padding>
  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-cancel-button class="cancel-button" (click)="cancelDialog()" [disabled]="false"></sc-cancel-button>
    <sc-content-spacer></sc-content-spacer>
    <sc-button primary (click)="suspendStation()"
      dictionaryKey="tmc-yard.ui.control.sac-client.suspend-station-dialog.action.confirm"
      [disabled]="isSupendStationDisabled()">
    </sc-button>
  </sc-actionbar>
</sc-sized-container>
